import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PartyLedgerListWrapper} from './party-ledgers-list/PartyLedgersList'
import {useEffect} from 'react'

const PartyLedgerPage = () => {
  // const loginData: any = localStorage.getItem('branch')
  // const currentUser = JSON.parse(loginData)
  useEffect(() => {
    document.title = 'PANEL | Reports'
  }, [])
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            path='party-ledger'
            element={
              <>
                <PartyLedgerListWrapper />
              </>
            }
          />
        </Route>

        <Route index element={<Navigate to='/report' />} />
      </Routes>
    </>
  )
}

export default PartyLedgerPage
